import { getAtpVersion } from "../services/VersionService";

export const getQrBaseUrl = (school, jwt) => {

  return getAtpVersion(school, jwt).then((results) => {
    return new Promise((resolve) => {
      if (process.env.NODE_ENV && process.env.NODE_ENV === "development") {
        resolve(`http://localhost:3003/#`);
      } else {
        // const subdomain = window.location.hostname.split('.').slice(0, -2).join('.');
        resolve(`https://${school.subdomain}.alltimely.com/#`);
      }
    });
  });
};

export const startCamera = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    const videoElement = document.getElementById('video');
    videoElement.srcObject = stream;
  } catch (error) {
    console.error('Error accessing camera:', error);
  }
};